
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { format, utcToZonedTime } from 'date-fns-tz';
import { mapState } from 'vuex';
import { User } from '@/models/main';
import { statesTimeZonesList } from '@/utils/PortalConstants';

@Component({
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class DateTimezoneToggle extends Vue {
  @Prop({ type: String, default: '', required: true }) private readonly dateString!: string;
  @Prop({ type: String, default: 'yyyy-MM-dd hh:mm:ss a' }) private readonly pattern!: string;
  @Prop({ type: String }) private readonly state!: string;

  private user: User;
  private statesTimeZonesList = statesTimeZonesList;
  private formattedDate = '';

  // dates & codes:
  // we get dates in Australia/Sydney time zone
  private defaultTimezone = 'Australia/Sydney';
  // user time zone
  private userTimezone = '';
  private userTimezoneCode = '';
  // job local time zone
  private localTimezone = '';
  private localTimezoneCode = '';
  // chosen time zone
  private chosenTimezone = '';
  private chosenTimezoneCode = '';

  // converting date to Australia/Sydney UTC and the to the local date
  private convertStringToDateTimezoneFormat(dateString: string, timezone: string, pattern: string): void {
    const date = new Date(dateString);
    const dateTimeZoned = utcToZonedTime(date, timezone);
    this.formattedDate = format(dateTimeZoned, pattern);
  }

  private setDefaultValues(): void {
    // user time zone
    this.userTimezone = this.user.timezone || this.defaultTimezone;
    // default is user time zone
    this.chosenTimezone = this.userTimezone;
    // job local time zone
    let stateCode = '';
    this.state ? (stateCode = this.state) : (stateCode = 'NSW');
    this.localTimezone = this.statesTimeZonesList[stateCode].timezone;
    this.localTimezoneCode = this.statesTimeZonesList[stateCode].code;

    // setting time zone codes
    const chosenTimezoneCodeIdx = Object.values(this.statesTimeZonesList).findIndex(
      x => x.timezone === this.chosenTimezone,
    );
    if (chosenTimezoneCodeIdx >= 0) {
      const stateCode = Object.keys(this.statesTimeZonesList)[chosenTimezoneCodeIdx];
      this.userTimezoneCode = this.statesTimeZonesList[stateCode].code;
      this.chosenTimezoneCode = this.userTimezoneCode;
    }

    // setting the date
    this.convertStringToDateTimezoneFormat(this.dateString, this.chosenTimezone, this.pattern);
  }

  private dateToggle(): void {
    if (this.userTimezone !== this.localTimezone) {
      // toggle user / local time zone
      this.chosenTimezone === this.localTimezone
        ? (this.chosenTimezone = this.user.timezone || this.defaultTimezone)
        : (this.chosenTimezone = this.localTimezone);

      // setting state codes
      const chosenTimezoneCodeIdx = Object.values(this.statesTimeZonesList).findIndex(
        x => x.timezone === this.chosenTimezone,
      );
      if (chosenTimezoneCodeIdx >= 0) {
        const stateCode = Object.keys(this.statesTimeZonesList)[chosenTimezoneCodeIdx];
        this.chosenTimezoneCode = this.statesTimeZonesList[stateCode].code;
      }

      // setting the date
      this.convertStringToDateTimezoneFormat(this.dateString, this.chosenTimezone, this.pattern);
    }
  }

  // watcher for the dashboard (drill-down clearing)
  @Watch('dateString', { immediate: true })
  private dateWatch() {
    this.setDefaultValues();
  }

  private mounted(): void {
    this.setDefaultValues();
  }
}
